import { useQuery } from '@tanstack/react-query';
import { getOrderCustomData } from 'config/requests/orders';

export function useGetOrderCustomData(id: string | undefined) {
  const { data, isFetching } = useQuery({
    queryKey: ['order_custom_data', id],
    queryFn: () => getOrderCustomData(id!),
    enabled: Boolean(id),
  });

  return {
    data,
    isFetching,
  };
}
